<template>
<div>
  <b-card class="m-2 mr-3">
    <p>Create {{showSelectedType}} Extensible SMS</p>
    <div class="form-row mb-3">
      <b-col cols="12" sm="12">
        <input type="text" v-model="heading" class="form-control" id="heading" maxlength="50" placeholder="Enter caption">
        <small class="text-muted">Purpose of the {{showSelectedType}}</small>
        <div class="pull-right">
          <span class="small" :class="[isHeadingLimit ? 'text-danger' : 'muted']">{{ headingCharacters }}</span>
        </div>
      </b-col>
    </div>
    <!-- <div class="form-row mb-3">
      <b-col cols="12" sm="12">
        <v-select id="selectedMedia" v-model="selectedMedia" :options="formats" placeholder="Add media"></v-select>
      </b-col>
    </div> -->
    <div class=" mb-3">
      <b-card no-body
            header-tag="header"
            footer-tag="footer" class="mb-1">
            <div slot="header" class="p-0 pt-1">
              <span class="mt-5">{{typeMessage}} </span>
              <b-button @click="showAddModal = true" class="icons pull-right fa fa-plus btn btn-pill btn-success active btn-sm"> Add</b-button>
            </div>
        </b-card><small class="text-muted">Click on the green <b>Add</b> button to type your questions and options.</small>
        <b-list-group>
            <b-list-group-item class="flex-column align-items-start"
                v-for="(questionnaire, index) in questionnaires"
                :key="index"
            >
                <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{`${index+1}. ${questionnaire.question}`}}</h5>
                <b-button variant="ghost-danger" class="btn-sm" @click="removeQuestion(index)">Remove</b-button>
                </div>
                <b-form-group class="ml-3">
                    <b-form-checkbox-group disabled stacked id="basicCheckboxes" name="Checkboxes">
                    <b-form-checkbox 
                        v-for="(option, i) in questionnaire.options"
                        :key="i">{{option}}</b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-list-group-item>
        </b-list-group>
    </div>
    <div class="form-row mb-3">
        <b-col cols="12" sm="12">
            <input type="text" v-model="message" class="form-control" id="heading" maxlength="100" placeholder="Enter thank you message">
            <small class="text-muted">The message that will be shown to the visitor after completing the {{showSelectedType}}</small>
        <div class="pull-right">
          <span class="small" :class="[isExmessageLimit ? 'text-danger' : 'text-muted']">{{ exMessageCharacters }}</span>
        </div>
        </b-col>
    </div>
    <b-form-group>
        <b-form-group>
          <template slot="label"><strong>Target audience</strong></template>
          <div class="mb-3">
            <b-form-radio v-model="audience" name="rbAudience" value="1">Public {{showSelectedType}}, no SMS Newsletter subscription is required</b-form-radio>
          </div>
          <div class="mb-3">
            <b-form-radio v-model="audience" name="rbAudience" value="2">Private {{showSelectedType}} for existing SMS Newsletter subscribers</b-form-radio>
            <div class="form-row mb-3 ml-3" v-if="audience==2">
              <b-col cols="12" sm="12">
                <v-select id="privateNewsletter" v-model="selectedNewsletter" :options="newsletters" placeholder="Select free SMS Newsletter"></v-select>
              </b-col>
            </div>
        </div>
        <div class="mb-3">
          <b-form-radio v-model="audience" name="rbAudience" value="3">Public {{showSelectedType}}, but requires SMS Newsletter subscription</b-form-radio>
          <div class="form-row mb-3 ml-3" v-if="audience==3">
            <b-col cols="12" sm="12">
              <v-select id="publicNewsletter" v-model="selectedNewsletter" :options="newsletters" placeholder="Select free SMS Newsletter"></v-select>
              <small class="text-danger">Note that you're the one to pay for the OTPs that will be sent to subscribers to verify their phone numbers. Do make sure your Zigatext account is well funded to avoid denying your audience access to your content.</small>
            </b-col>
          </div>
        </div>
      </b-form-group>
    </b-form-group>
    <b-button variant="primary" type="button" @click="handleCreate" block>
    <span>{{actionText}}</span>
        <div class="sk-circle" v-if="loading || uploading">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
        <i v-if="flashSendError" class="fa fa-times"></i>
    </b-button>
  </b-card>
   <b-modal title="Add option" hide-footer v-model="showAddModal">    
        <template>
          <div class="form-row mb-3">
            <b-col cols="12" sm="12">
              <input type="text" v-model="question" class="form-control" :placeholder="questionPlaceholder">
            </b-col>
          </div>
          <div class="form-row">
            <b-col cols="12" sm="12">
              <textarea v-model="options" class="form-control" id="pn" :placeholder="optionsPlaceholder"></textarea>
              <small><span class="text-danger">Each choice should be on its own newline</span></small>
            </b-col>
          </div>
        </template>
        <b-button type="button" variant="primary" class="mt-1" block @click="handleAdd">
          <span>Add</span>
        </b-button>
    </b-modal>
</div>
</template>

<script>
import Vue from "vue"
import vSelect from 'vue-select'
import { mapGetters, mapActions, mapState } from "vuex"

export default {
  name: 'Questionnaire',
  components: {
    vSelect,
  },
  data () {
    return {
      modalTitle: 'Create Vote Extensible SMS',
      actionText: 'Create',
      heading: '',
      audience: 1,
      message: '',
      text:'the message is infomative',
      headingCharacters: '',
      exMessageCharacters: '',
      showAddModal: false,
      fileNote: '',
      isHeadingLimit: false,
      isExmessageLimit: false,
      selectedNewsletter: null,
      uploading: false,
      question: '',
      options: '',
      questionnaires: [],
      //isMediaSelected: false,
      flashSendError: false
    }
  },
  notifications: {
    validationError: {
      title: 'Error',
      message: 'Kindly type in your message content and heading.',
      type: 'error'
    },
    showFailedError: {
      title: 'Error',
      message: 'This was an error creating your questionnaire.',
      type: 'error'
    },
    showCreatedSuccess: {
      title: 'Success',
      message: 'Created successfully.',
      type: 'success'
    },
  },
  props: {
    showSelectedType: String,
    newsletters: {
      type: Array,
      required: false,
      default: () => []
    },
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('extensibleSms', ['mediaTypes', 'loading']),
    ...mapGetters('extensibleSms', ['loading']),
    formats: function() {
      let options = []
      for(let i = 0; i < this.mediaTypes.length; i++)
        options.push({value: this.mediaTypes[i].id, label: this.mediaTypes[i].mediaName})
        return options
    },
    typeMessage: function() {
        let message = 'Poll preferences and options'
        if (this.showSelectedType == 'vote') {
            message = 'Vote positions and candidates'
        } else if (this.showSelectedType == 'survey') {
            message = 'Survey questions and options'
        }

        return message
    },
    questionPlaceholder: function() {
        let placeholder = 'Enter poll item'
        if (this.showSelectedType == 'vote') {
            placeholder = 'Enter vote position'
        } else if (this.showSelectedType == 'survey') {
            placeholder = 'Enter survey question'
        }

        return placeholder
    },
    optionsPlaceholder: function() {
        let placeholder = 'Enter each poll opinion per newline'
        if (this.showSelectedType == 'vote') {
            placeholder = 'Enter each candidate per newline'
        } else if (this.showSelectedType == 'survey') {
            placeholder = 'Enter each survey option per newline'
        }

        return placeholder
    },
  },
  mounted() {
    //this.getMediaTypes();
  },
  methods: {
    ...mapActions('extensibleSms', [
        'createQuestionnaire'
    ]),
    handleAdd: function() {
        if (this.question.trim() == '' && this.options.trim() == '') {
            this.validationError({message:'All fields are required.'})
            return
        }

        let options = this.options.split('\n')
        if (options.length <= 1) {
            this.validationError({message:'More than one choice are required.'})
            return
        }
        let questionnaire = {
            question: this.question,
            options: options
        }
        this.questionnaires.push(questionnaire)
        this.question = ''
        this.options = ''
    },
    removeQuestion: function(index) {
        for( let i = 0; i < this.questionnaires.length; i++) { 
            if ( i === index) {
                this.questionnaires.splice(i, 1)
                break
            }
        }     
    },
    async handleCreate() {
      if(this.questionnaires.length < 1) {
        this.validationError({message: 'Kindly add '+this.showSelectedType+' items.'})
        return
      }

      this.actionText = '';

      let typeText = 'poll'
      let type = 3
      if (this.showSelectedType == 'vote') {
          type = 2
          typeText = 'vote'
      } else if (this.showSelectedType == 'survey') {
          type = 1
          typeText = 'survey'
      }

      const requestData = {
        "caption": this.heading.trim().length > 0 ? this.heading.trim() : this.showSelectedType,
        "message": this.message.trim().length > 0 ? this.message.trim() : "Thank you for participating.",
        "uuid": this.user.uuid,
        "subcode": this.selectedNewsletter != null ? this.selectedNewsletter.value : "",
        "type": type,
        "audience": this.audience,
        "questionnaire": this.questionnaires,
      }

      let status = await this.createQuestionnaire({data: requestData, type: typeText})
      if (status) {
        this.showCreatedSuccess({message:`Creation of ${typeText} was successfully.`})
      } else {
        this.showFailedError({message:`This was an error creating your ${typeText}.`})
      }
      this.actionText = 'Create';
    },
  },
  watch: {
      heading(newValue, oldValue) {
        let inputLen = 50;
        this.headingCharacters = (this.heading.length == 0) ? '' : `(Maximum Charaters: ${inputLen}), Characters left: ${(inputLen-this.heading.length)}, Typed Characters: ${this.heading.length}`;
        this.isHeadingLimit = this.heading.length >= inputLen
      },
      message(newValue, oldValue) {
        let inputLen = 100;
        this.exMessageCharacters = (this.message.length == 0) ? '' : `(Maximum Charaters: ${inputLen}), Characters left: ${(inputLen-this.message.length)}, Typed Characters: ${this.message.length}`;
        this.isExmessageLimit = this.message.length >= inputLen
      }
  },
}
</script>

<style type="text/css" scoped>
  .border-color {
      border: 1px #edebe9 solid;
  }
  .sk-circle{
    margin: 0 auto 1px auto;
    width: 20px;
    height: 20px;
    position: relative;
    color: white !important;
  }
</style>